import React from 'react';
import { Grid, Heading } from 'ui';
import { FileUploader } from '@components/FileUploader';
import { FileAlert, FileWarningAlert } from './components';
import { useController } from './hooks';

export const DocumentSection = ({
  t,
  name,
  control,
  document,
  resetForm,
  isDisabled,
  clearField,
  onUploadError,
  onUploadCompleted,
  onRemoveCompleted,
  filesCount: filesCountProp,
}) => {
  const {
    filesCount,
    isUploading,
    onRemoveFile,
    uploadedFiles,
    rejectedFiles,
    isRemoveLoading,
    fileFieldOptions,
    showRejectedAlert,
  } = useController({
    control,
    document,
    resetForm,
    clearField,
    onUploadError,
    onUploadCompleted,
    onRemoveCompleted,
    filesCount: filesCountProp,
  });

  return (
    <Grid padding="5" rowGap="2">
      <Heading as="h3" fontSize="md" fontWeight="medium">
        {t(`fields.${name}.label`)}
      </Heading>
      {showRejectedAlert && (
        rejectedFiles.map(({ id, fileName, message }) => (
          <FileWarningAlert
            id={id}
            message={message}
            fileName={fileName}
          />
        ))
      )}
      <FileUploader
        name={name}
        control={control}
        filesCount={filesCount}
        isDisabled={isDisabled || isUploading}
        accept="application/pdf, image/jpeg, image/png"
        placeholder={t(`fields.${name}.placeholder`)}
        {...fileFieldOptions}
      />
      {uploadedFiles.map((props) => (
        <FileAlert
          key={props.id}
          isLoading={isRemoveLoading}
          onRemoveFile={() => onRemoveFile({ attachmentId: props.id })}
          {...props}
        />
      ))}
    </Grid>
  );
};
